module.exports = __webpack_public_path__ + "img/user.a2e618b0.svg";